/**
 * Created by vladislav on 3/4/19
 */

const ClockCellView = BaseCellView.extend({
    ctor: function (clockCell) {
        this._super();

        if (clockCell.isForGoal) {
            const styles = this.getStyles();
            this.setAnchorPoint(0.5, 0.5);
            this.setContentSize2(styles.goal.width, styles.goal.height);
            const goal = new cc.Sprite(bundles.clock.frames.clock_goal);
            this.addChild(goal);
            goal.setAlignment(this.width / 2, this.height / 2);
            return;
        }

        const bigComponent = clockCell.findComponent(BigComponent);
        if (!bigComponent.isHead) {
            return;
        }

        this.initialize(clockCell);

        this.createBg();
        this.createItems(clockCell);
    },

    createBg: function () {
        const bg = this.bg = new cleverapps.Spine(bundles.clock.jsons.clock_json);
        bg.setAnimation(0, "animation", true);
        bg.setLocalZOrder(10);
        this.addChild(bg);
        bg.setAlignment(this.width / 2, this.height / 2);
    },

    createItems: function (clockCell) {
        if (this.items) {
            this.items.forEach((item) => {
                item.view.removeFromParent(true);
            });
        }
        this.items = [];

        clockCell.colors.forEach((color, index) => {
            const item = this.createItem(color);
            this.addChild(item);

            item.setAnchorPoint(0, 0.5);
            item.setAlignment(this.width / 2, this.height / 2);
            item.setRotation(this.calcRotation(index));
            item.setScaleY(this.calcScale());
            item.setLocalZOrder(clockCell.colors.length - index);

            if (index === 0) {
                this.addCurrentAnimation(item);
                item.setScaleY(item.getScaleY() * 1.2);
            }

            this.items.push({ view: item });
        });
    },

    removeCurrentAnimation: function (item) {
        if (item.currAnimation) {
            item.stopAction(item.currAnimation);
            delete item.currAnimation;
        }
    },

    addCurrentAnimation: function (item) {
        const baseScaleX = item.getScaleX();
        const baseScaleY = item.getScaleY();
        item.currAnimation = item.runAction(new cc.RepeatForever(
            new cc.Sequence(
                new cc.ScaleTo(0.4, baseScaleX * 1.1, baseScaleY * 1.1),
                new cc.ScaleTo(0.4, baseScaleX, baseScaleY)
            )
        ));
    },

    createItem: function (color) {
        const animation = new cleverapps.Spine(bundles.clock.jsons.petal_json);
        animation.setSkin(ColorComponent.CODE_COLORS[color]);
        animation.setAnimation(0, "idle_1", false);

        const item = new cc.Node();
        item.setAnchorPoint(0.5, 0.5);
        item.setContentSize2(this.getStyles().animation);
        item.addChild(animation);
        item.animation = animation;
        animation.setAlignment(animation.width / 2, animation.height / 2);

        return item;
    },

    calcScale: function () {
        const minScale = 0.55, maxScale = 1.4;
        const step = (maxScale - minScale) / this.cell.getMaxLives();
        return minScale + step * (this.cell.getMaxLives() - this.cell.colors.length);
    },

    calcRotation: function (index) {
        const INITIAL_ROTATION = -90;
        return 360 / this.cell.colors.length * index + INITIAL_ROTATION;
    },

    initialize: function (clockCell) {
        this._super(clockCell);

        clockCell.onChangeLivesListener = this.createListener(this.changeLives.bind(this));
        this.setAlignment(BaseCellView.alignInTheGrid(clockCell.x + 0.5, clockCell.y + 0.5));
    },

    calcPosition: function (item, dist) {
        const unitVector = { x: Math.cos(-item.rotation * Math.PI / 180), y: Math.sin(-item.rotation * Math.PI / 180) };
        return cc.p(item.x + unitVector.x * dist, item.y + unitVector.y * dist);
    },

    changeLives: function () {
        const styles = this.getStyles();

        const goalItem = this.items[0].view;
        goalItem.replaceParentSamePlace(this.parent);

        this.items.shift();

        const movePosition = this.calcPosition(goalItem, styles.moveBy.distance);

        this.setLocalZOrder(9);
        this.removeCurrentAnimation(goalItem);

        goalItem.runAction(new cc.Sequence(
            new cc.MoveTo(0.2, movePosition),
            new cc.CallFunc(() => {
                if (!Game.currentGame) {
                    return;
                }

                const goal = Game.currentGame.goals.findTargetFor(this.cell.getGoalId());
                goal.collect(1, goalItem);
                goalItem.runAction(new cc.RotateTo(0.3, -90));
            })
        ));

        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.6),
            new cc.CallFunc(() => {
                this.setLocalZOrder(this.baseZOrder);
                this.rotateAll();
            })
        ));
    },

    rotateAll: function () {
        this.items.forEach((item, index) => {
            item.view.runAction(new cc.Sequence(
                new cc.Spawn(
                    new cc.ScaleTo(0.3, 1, this.calcScale()),
                    new cc.RotateTo(0.3, this.calcRotation(index))
                ),
                new cc.CallFunc(() => {
                    if (index === 0) {
                        item.view.runAction(new cc.Sequence(
                            new cc.ScaleTo(0.3, item.view.getScaleX(), item.view.getScaleY() * 1.2),
                            new cc.CallFunc(() => {
                                this.addCurrentAnimation(item.view);
                            })
                        ));
                    }
                })
            ));
        });
    },

    unuse: function () {
        this.cell.onChangeLivesListener = function () {};

        this._super();
    },

    getStyles: function () {
        return cleverapps.styles.ClockCellView;
    }
});

cleverapps.styles.ClockCellView = {
    radius: 75,

    hover: {
        y: 10
    },

    goal: {
        width: 120,
        height: 120
    },

    animation: {
        width: 100,
        height: 100
    },

    moveBy: {
        distance: 70
    }
};